import { Box } from '@chakra-ui/react';
import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { AiFillCaretDown, AiFillCaretUp, AiOutlineLine } from 'react-icons/ai';

import {
  ColumDef,
  CustomHeaderGroup,
  FooterProps,
} from '../../../../interfaces';
import { useTabsViewsContext } from '../../../TabsViews';
import { CellFooter } from './styles';

const DEFAULT_HEADER_STYLE = {
  flex: 1,
};

const Footer: React.FC<FooterProps> = ({
  headerGroup,
  footerBackgroundColor,
  footerBorderColor,
  footerTextColor,
  footerTextWeight,
  footerFontSize,
  footerIconType,
  footerIconColor,
  footerIconSize,
  footer,
  restColumns,
}) => {
  const { hasTabs, activeTabs } = useTabsViewsContext();

  return (
    <div className="innerFooter">
      {headerGroup.headers?.map((column: CustomHeaderGroup, index) => {
        const footerReferenced = footer.find((f) => f.key === column.id);

        const {
          hasArrow,
          header,
          justifyContent,
          minWidth,
          key,
          width,
          arrowDirection,
          arrowColor,
          arrowSize,
        } = footerReferenced || footer?.[index] || {};
        const { id, originalId } = column;

        const footerComponent = flexRender(header, column.getContext());

        const { accessorKey } = column?.column?.columnDef as ColumDef;

        const { flex = 1 } =
          restColumns[accessorKey || originalId || id] ?? DEFAULT_HEADER_STYLE;

        const flexSize =
          index === 0 && hasTabs
            ? 1 +
              Array.from(activeTabs?.values())?.filter(
                (item) => item?.selected?.length > 0,
              )?.length
            : flex;

        return (
          <CellFooter
            key={key}
            width={width}
            minWidth={minWidth || 0}
            justifyContent={justifyContent}
            footerBackgroundColor={footerBackgroundColor || 'transparent'}
            footerBorderColor={footerBorderColor || 'transparent'}
            footerTextColor={footerTextColor || '#7d7d7d'}
            footerTextWeight={footerTextWeight || '#7d7d7d'}
            footerFontSize={footerFontSize || '10px'}
            style={{ flex: flexSize }}
          >
            {hasArrow &&
              (arrowDirection ? (
                <Box
                  display="flex"
                  justifyContent={justifyContent ?? 'center'}
                  width="100%"
                >
                  <span>
                    {arrowDirection === 'positive' && (
                      <AiFillCaretUp
                        color={arrowColor ?? '#00b400'}
                        size={arrowSize ?? 18}
                      />
                    )}
                    {arrowDirection === 'negative' && (
                      <AiFillCaretDown
                        color={arrowColor ?? '#FF2E2E'}
                        size={arrowSize ?? 18}
                      />
                    )}
                    {arrowDirection === 'equal' && (
                      <AiOutlineLine
                        color={arrowColor ?? '#FFEF00'}
                        size={arrowSize ?? 18}
                      />
                    )}
                  </span>
                  <span>{header}</span>
                </Box>
              ) : (
                <Box
                  display="flex"
                  justifyContent={justifyContent ?? 'center'}
                  width="100%"
                >
                  <span>
                    {footerIconType === 'positive' && (
                      <AiFillCaretUp
                        color={footerIconColor}
                        size={footerIconSize}
                      />
                    )}
                    {footerIconType === 'negative' && (
                      <AiFillCaretDown
                        color={footerIconColor}
                        size={footerIconSize}
                      />
                    )}
                    {footerIconType === 'equal' && (
                      <AiOutlineLine
                        color={footerIconColor}
                        size={footerIconSize}
                      />
                    )}
                  </span>
                  <span>{header}</span>
                </Box>
              ))}
            {!hasArrow && footerComponent}
          </CellFooter>
        );
      })}
    </div>
  );
};

export default Footer;
